import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

/**
 * CustomerRouteGuard - Protects customer-only routes
 * Redirects admin users to admin dashboard
 * Redirects unauthenticated users to customer login
 */
export default function CustomerRouteGuard({ children }) {
  const { user, loading } = useAuth()

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  // No user - redirect to customer login
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Admin user - redirect to admin dashboard (check multiple conditions)
  const adminToken = localStorage.getItem('admin_auth_token')
  if (user.isAdmin || adminToken) {
    console.log('CustomerRouteGuard: Admin user detected, redirecting to admin dashboard')
    return <Navigate to="/dashboard" replace />
  }

  // Handover-agent sub-user - belongs on the dedicated takeover console
  if (user.role === 'handover_agent') {
    return <Navigate to="/agent-dashboard" replace />
  }

  // Customer user - allow access
  return children
}